import React, { useEffect, useState } from 'react'
import { Container, Card,  Row, Col, Form, ButtonGroup, Button, Modal } from "react-bootstrap";
import PageTitle from '../components/common/PageTitle';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import api from '../api/api';
import swal from 'sweetalert';
import Pagination from '../views/Pagination';
import '../styles/management-pages.css';
import './ConfigurationManagement.css';

const ConfigurationCities = () => {

    const navigate = useNavigate()

    const [countrysPerPage] = useState(12)
    const [currentPage, setCurrentPage] = useState(1);

    const [SearchCode, setSearchCode] = useState('')
    const [SearchName, setSearchName] = useState('')


    const paginate = pageNumber => setCurrentPage(pageNumber);

    const { t } = useTranslation();

    const [lat, setLat] = useState("")
    const [lon, setLon] = useState("")
    const [toggle ,setToggle] = useState(false)

    const [allCountry, setAllCountry] = useState([])

    const [allCities, setAllCities] = useState([])

    const [city, setCity] = useState("")
    const [countryCode, setCountryCode] = useState("")
    const [country, setCountry] = useState("")

    const getCities = async () => {
            try {
                    await api.get('/cities/get-cities')
                    .then(response=>{
                        if(response.data.type === "success"){
                            let listCities = response.data.Cities
                            setAllCities(listCities)

                        }
                    }).catch(error =>{
                        console.error(error)
                    })

            } catch (error) {
                console.error(error)
            }
    }
    useEffect(() => {
        const getCountries = async () => {
            try {
                    await api.get('/countries/get-countries')
                    .then(response=>{
                        if(response.data.type === "success"){
                            let listCountries = response.data.Countries
                            setAllCountry(listCountries)
                        }
                    }).catch(error =>{
                        console.error(error)
                    })

            } catch (error) {
                console.error(error)
            }
    }
    getCountries()
        getCities()
    }, [])

    const addCities = () => {
        let data = {
            country : country,
            iso : countryCode ,
            city : city,
            lat : lat,
            lon :lon,
        }

        api.post('/cities/add-cities',data)
        .then(response=>{
            if(response && response.data.type === "success"){
                swal(`${t('City_Added')}`, { icon: "success" });
                getCities()
                setToggle(false)
                setCity('')
                setCountry('')
                setCountryCode('')
                setLat('')
                setLon('')
            }
            if(response && response.data.type === "danger"){
                swal(`${t('Error_Adding_City')}`, { icon: "error" });
            }
        }).catch(error=>{
            console.error(error)
        })
    }

    const handleDelete = async cityId => {
        let data = {
            city_id: cityId,
        }
        return await api.delete('/cities/delete-city', { data: data })
            .then(response => {
                if (response.data.type && response.data.type == "danger") {
                    swal({
                        title: t("cannot_delete_city"),
                        icon: "warning",
                    });
                    return false;
                }
                if (response.data.type == "success") {
                    getCities();
                    return true;
                }
                return false;
            }).catch(error => {
                swal({
                    title: t("cannot_delete_city"),
                    icon: "error",
                    text: t("error_delete_city")

                });
                return false;
            })
        }

    const confirmDelete = cityId => {

        swal({
            title: t("Are you sure?"),
            text: t("city_delete_warning"),
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then(async (Delete) => {
                if (Delete) {
                    const deleted = await handleDelete(cityId)
                    if (deleted) {
                        swal(t("city_deleted"), {
                            icon: "success",
                        });
                    }
                }
            }).catch(error => {
                swal({
                    title: t("cannot_delete_city"),
                    icon: "error",
                    text: t("error_delete_city")

                });
            })

    }

    const filteredCities = allCities.filter(city => {
        if (SearchName !== '') {
            return (
                city.city.toLowerCase().includes(SearchName.toLowerCase())
            )
        }
        if (SearchCode !== '') {
            return (
                city.iso.toLowerCase().includes(SearchCode.toLowerCase())
            )
        }
        return city
    })
    const indexOfLastPost = currentPage * countrysPerPage;
    const indexOfFirstPost = indexOfLastPost - countrysPerPage;
    const currentCities = filteredCities.slice(indexOfFirstPost, indexOfLastPost);

    return (
        <>
        <Container fluid className="management-page admin-management-page configuration-management-page">
            <header className="management-page-header">
                <div className="management-page-heading">
                    <span className="management-page-eyebrow">SMARTFARM / ADMIN</span>
                    <h1>{t('Cities_Configuration')}</h1>
                    <p>{t('Cities_Configuration')}</p>
                </div>
                <span className="management-header-icon" aria-hidden="true">
                    <i className="fas fa-city" />
                </span>
            </header>
            <section className="management-filter">
                <span className="management-section-label">{t('search')}</span>
                <Row form className="d-flex justify-content-start gap-2 mt-2">
                    <Col md="3" className="form-group">
                        <Form.Group>
                            <div className="d-flex">
                                <Form.Control
                                    value={SearchName}
                                    onChange={(e) => setSearchName(e.target.value)}
                                    id="search-name"
                                    placeholder={t('search_by_name')}/>

                            </div>
                        </Form.Group>
                    </Col>
                    <Col md="3" className="form-group">
                        <Form.Group>
                            <div className="d-flex">
                                <Form.Control
                                     value={SearchCode}
                                     onChange={(e) => setSearchCode(e.target.value)}
                                    id="search-code"
                                    placeholder={t('search_by_code')} />

                            </div>
                        </Form.Group>
                    </Col>
                </Row>
            </section>
                <Row form className="py-3 d-flex justify-content-end">
                    <ButtonGroup>
                        <Button className="management-primary-button" variant='primary' onClick={() => {setToggle(true)}}>
                            <i className="fas fa-plus me-2" aria-hidden="true" />{t('add_city')}
                        </Button>
                    </ButtonGroup>

                </Row>
                <Card className="management-card">
                    <Card.Header className="border-bottom">
                        <div>
                            <h5>
                                {t('Location_Info')}

                            </h5>

                        </div>
                    </Card.Header>
                    <Card.Body>
                    <table className="table mb-0 text-center">
                        <thead className="bg-light">
                            <tr>
                                <th scope="col" className="border-0">{t('Country_Name')}</th>
                                <th scope="col" className="border-0">{t('City Name')}</th>
                                <th scope="col" className="border-0">{t('code')}</th>
                                <th scope="col" className="border-0">{t('Latitude')}</th>
                                <th scope="col" className="border-0">{t('Longitude')}</th>
                                <th scope="col" className="border-0"></th>

                            </tr>
                        </thead>
                        <tbody>
                            {
                                currentCities.map(city=>{
                                    return(
                                        <tr>
                                            <td>{city.country}</td>
                                            <td>{city.city}</td>
                                            <td>{city.iso}</td>
                                            <td>{city.lat}</td>
                                            <td>{city.lon}</td>


                                            <td>
                                               
                                                        <ButtonGroup size="sm" className="mr-2">
                                                            <Button title={t('edit')} onClick={() => navigate(`/admin/configuration/cities/weather/${city.id}`) } variant="info"><i className="fas fa-pen" aria-hidden="true" /></Button>
                                                            <Button title={t('delete')} onClick={() => confirmDelete(city.id)} variant="danger"><i className="fas fa-trash" aria-hidden="true" /></Button>
                                                        </ButtonGroup>
                                                

                                            </td>
                                            
                                        </tr>

                                    )
                                })
                            }


                        </tbody>
                    </table>
                    </Card.Body>
                </Card>
                <Row className="py-4 justify-content-center">
                    <Pagination usersPerPage={countrysPerPage} totalUsers={filteredCities.length} paginate={paginate} currentPage={currentPage} />

                </Row>
        </Container>
        <Modal centered={true} show={toggle} onHide={() => setToggle(false)}>
                        <Modal.Header closeButton className="d-flex justify-content-between align-items-center">
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",

                                }}
                            >
                                <Button
                                    onClick={()  => {addCities()}}
                                    className="mb-2 mr-1 btn btn-success"
                                >
                                    <i className="fa fa-check mx-2"></i>
                                    {t('save')}
                                </Button>
                                <Button
                                    className="mb-2 mr-1 btn btn-danger"
                                    onClick={() => {setToggle(false)} }
                                >
                                    <i className="fa fa-times mx-2"></i>
                                    {t('cancel')}
                                </Button>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className='d-flex justify-content-center border-bottom'>
                                <Col lg='6' md='8' sm='8'>
                                    <Form.Group>
                                        <label htmlFor="country">{t('Country')}</label>
                                            <Form.Select
                                                value={country}
                                                onChange={(e) =>{ setCountry(e.target.value.split('_')[0]) ;setCountryCode(e.target.value.split('_')[1])}}
                                                id="country"

                                            >
                                                <option value="">{t('select_country')}</option>

                                                {
                                                            allCountry.map((optionCountry)=>{
                                                                return(
                                                                    <option key={optionCountry.iso} value={`${optionCountry.name}_${optionCountry.iso}`}>{optionCountry.name}</option>
                                                                )
                                                            })
                                                }
                                            </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col lg='6' md='8' sm='8'>
                                    <Form.Group>
                                        <label htmlFor="countryCode">{t('Country Code')}</label>
                                            <Form.Control
                                                value={countryCode}
                                                onChange={(e) => setCountryCode(e.target.value) }
                                                id="countryCode"
                                                placeholder={t('Country Code')}

                                            />
                                    </Form.Group>
                                </Col>
                            </Row>
                                <Row className="py-2">
                                <Col lg='6' md='8' sm='8'>
                                    <Form.Group>
                                        <label htmlFor="city">{t('City Name')}</label>
                                            <Form.Control
                                                value={city}
                                                onChange={(e) => setCity(e.target.value) }
                                                id="city"
                                                placeholder={t('City Name')}
                                            />
                                    </Form.Group>
                                </Col>
                                <Col lg='3' md='8' sm='8'>
                                    <Form.Group>
                                        <label htmlFor="lat">{t('Latitude')}</label>
                                            <Form.Control
                                            value={lat}
                                            onChange={(e) => setLat(e.target.value) }
                                                id="lat"
                                                placeholder={t('Latitude')}
                                            />
                                    </Form.Group>
                                </Col>
                                <Col lg='3' md='8' sm='8'>
                                    <Form.Group>
                                        <label htmlFor="lon">{t('Longitude')}</label>
                                            <Form.Control
                                             value={lon}
                                             onChange={(e) => setLon(e.target.value) }
                                                id="lon"
                                                placeholder={t('Longitude')}
                                            />
                                    </Form.Group>
                                </Col>
                                </Row>

                        </Modal.Body>
        </Modal>
        </>
    )
}

export default ConfigurationCities
